import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const NotFound = () => import("../views/404");

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login.vue"),
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/data",
    name: "Data",
    component: () => import("../views/Data.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/workbench",
    name: "智能工作台",
    component: () => import("../views/workbench.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/actionLog",
    name: "操作日志",
    component: () => import("../views/actionLog.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/camera",
    name: "Camera",
    component: () => import("../views/Camera.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/h5-device",
    name: "H5Device",
    component: () => import("../views/h5-device.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/techFarm/tesk",
    name: "农事任务",
    component: () => import("../views/techFarm/tesk.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/techFarm/history",
    name: "农事记录",
    component: () => import("../views/techFarm/history.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/techFarm/guide",
    name: "种植指南",
    component: () => import("../views/techFarm/guide.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/techFarm/harvest/index",
    name: "产品采收",
    component: () => import("../views/techFarm/harvest/index.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/techFarm/harvest/add",
    name: "采收数据",
    component: () => import("../views/techFarm/harvest/add.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/techFarm/harvest/partition",
    name: "商品分拣",
    component: () => import("../views/techFarm/harvest/partition.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/breakingNews",
    name: "莓市速报",
    component: () => import("../views/breakingNews.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/management",
    name: "Management",
    component: () => import("../views/management/index.vue"),
    meta: {
      requireAuth: true,
    },
    redirect: "/management/roles",
    children: [
      {
        path: "menu",
        name: "Menu",
        component: () => import("../views/management/menu/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "roles",
        name: "Roles",
        component: () => import("../views/management/roles/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "accounts",
        name: "Accounts",
        component: () => import("../views/management/accounts/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "strawberry",
        name: "Strawberry",
        component: () => import("../views/management/strawberry/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "greenhouse",
        name: "Greenhouse",
        component: () => import("../views/management/greenhouse/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "growth",
        name: "Growth",
        component: () => import("../views/management/growth/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "storagePositions",
        name: "storagePositions",
        component: () => import("../views/management/storagePositions/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "tasks",
        name: "Tasks",
        component: () => import("../views/management/tasks/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "growth-period",
        name: "GrowthPeriod",
        component: () => import("../views/management/growth-period/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "farm-tasks",
        name: "FarmTasks",
        component: () => import("../views/management/farm-tasks/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "realTimeMonitoring",
        name: "RealTimeMonitoring",
        component: () =>
          import("../views/management/realTimeMonitoring/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "equipmentControl",
        name: "EquipmentControl",
        component: () =>
          import("../views/management/equipmentControl/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "monitoringEquipment",
        name: "MonitoringEquipment",
        component: () =>
          import("../views/management/monitoringEquipment/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "schedulingPage",
        name: "SchedulingPage",
        component: () => import("../views/management/schedulingPage/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "BaseIntroduction",
        name: "各基地介绍",
        component: () =>
          import("../views/management/BaseIntroduction/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "growthPictures",
        name: "生长时期图片",
        component: () =>
          import("../views/management/growthPictures/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "IndustryAndProvenance",
        name: "产业和种源",
        component: () =>
          import("../views/management/IndustryAndProvenance/index.vue"),
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
  { path: "*", component: NotFound },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  next();
  return;
  // 如果是登录页面,直接放行
  if (to.path === "/login") {
    next();
    return;
  }

  // 判断该路由是否需要登录权限
  if (to.meta.requireAuth) {
    if (token) {
      next();
    } else {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    }
  } else {
    next();
  }
});

export default router;
